import { Alert, Button } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
const AlertComponent = (props) => {
    const errorsdownload = props.errordownload
    if (props.businessValidationExists && (props.businessValidationStatus[0] === '') && (!props.technicalValidationExists)) {
        return (
                <Alert severity="success" title="Test is compliant. There are no issues with the file tested."></Alert>
        )
    }
    else {
        return (
            <Alert severity="error" >
              { "File Not Compliant. Errors are shown below or you can"} <Button  onClick={errorsdownload} startIcon={<SaveIcon />} >Download Errors</Button>
            </Alert>
        )
    }
}

export default AlertComponent;
